import posthog from "posthog-js";
import { type ConsentProvider } from "./consent-manager";

export const posthogConsentManager: ConsentProvider = {
    handleInitialConsent: (isGranted: boolean | undefined) => {
        if (typeof window === "undefined") return;
        if (isGranted) {
            posthog.set_config({ persistence: "localStorage+cookie" });
            posthog.startSessionRecording?.();
        }
    },

    handleConsentUpdate: (isGranted: boolean) => {
        if (typeof window === "undefined") return;
        if (isGranted) {
            posthog.set_config({ persistence: "localStorage+cookie" });
            posthog.startSessionRecording?.();
        } else {
            posthog.stopSessionRecording?.();
            posthog.set_config({ persistence: "memory" });
            posthog.reset();
        }
    },
};
